/** Evento global para sessão inválida/expirada (401 nas APIs). */
export const SESSION_EXPIRED_EVENT = "planejamento-tributario:session-expired";

export function emitSessionExpired() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
}
